import { render } from "./ResourcesFiltersMobile.vue?vue&type=template&id=4f83c8bb&scoped=true"
import script from "./ResourcesFiltersMobile.vue?vue&type=script&lang=js"
export * from "./ResourcesFiltersMobile.vue?vue&type=script&lang=js"

import "./ResourcesFiltersMobile.vue?vue&type=style&index=0&id=4f83c8bb&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f83c8bb"]])

export default __exports__